import _ from 'lodash'

const DEBOUNCE_WAIT_TIME = 400

export const debounce = (fn, wait = DEBOUNCE_WAIT_TIME, options) => _.debounce(fn, wait, options)
